import { render, staticRenderFns } from "./Appeal.vue?vue&type=template&id=356c0441&"
import script from "./Appeal.vue?vue&type=script&lang=ts&"
export * from "./Appeal.vue?vue&type=script&lang=ts&"
import style0 from "./Appeal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VDataTable,VSelect,VSkeletonLoader})
